import React, { useEffect } from "react";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { get2FAStatus } from "../../store/actions";
import TopBar from "./Topbar";
import SecurityAnnouncementModal from "./SecurityAnnouncementModal";
import AccountTypeOnboardingModal from "./AccountTypeOnboardingModal";
import Dashboard from "../../pages/Dashboard";
import Transactions from "../../pages/Transactions";
import Balances from "../../pages/Balances";
import ApiReference from "../../pages/ApiReference";
import Account from "../../pages/ChangePassword";
// import FeeManagement from "../../pages/feeManagement";
import WhitelistedIps from "../../pages/WhitelistedIps";
import WhitelistedWebsites from "../../pages/WhitelistedWebsites";
import Webhooks from "../../pages/Webhooks";

// import AvailableCoinsPairs from "../../pages/AvailableCoinsPairs";
import Widget from "../../pages/Widget";
import Referral from "../../pages/Referral";
import LinkedWallets from "../../pages/LinkedWallets";
import Security from "../../pages/Security";
import SubPartnerFees from "../../pages/SubPartnerFees";
import EditWallet from "../../pages/EditWallet";
import VipTiers from "../../pages/VipTiers";
import RevenueShare from "../../pages/RevenueShare";
import CampaignStats from "../../pages/CampaignStats";
import AgencyOverview from "../../pages/AgencyOverview";
import AgencyPartners from "../../pages/AgencyPartners";
import AgencyInvites from "../../pages/AgencyInvites";
import AgencyBanners from "./AgencyBanners";
import { useAgencyView } from "../../hooks/useAccountType";

const Main = ({ handleToggleSidebar }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const twoFactor = useSelector((s) => s.userReducer.twoFactor);
  // Agency "viewing as": remount every page when the viewed partner changes so
  // each one refetches with the new viewPartnerId.
  const agencyView = useAgencyView();

  useEffect(() => {
    dispatch(get2FAStatus());
  }, [dispatch]);

  return (
    <div className="isw-main">
      <SecurityAnnouncementModal />
      <AccountTypeOnboardingModal />
      <TopBar handleToggleSidebar={handleToggleSidebar} />
      {twoFactor.loaded && !twoFactor.enabled && (
        <div
          onClick={() => navigate("/security")}
          style={{
            width: "100%",
            padding: "12px 25px",
            background: "#3a2a12",
            borderBottom: "1px solid rgba(255,180,60,.35)",
            color: "#ffd8a6",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 10,
            fontSize: 14,
            fontWeight: 600,
          }}
        >
          ⚠ Two-factor authentication is not set up. Click here to activate it
          and enable withdrawals.
        </div>
      )}
      <AgencyBanners />
      <div className="isw-body">
        <Routes key={agencyView?.id || "own"}>
        <Route path="/overview" element={<Dashboard />} />
        <Route path="/transactions" element={<Transactions />} />
        <Route path="/balances" element={<Balances />} />
        <Route path="/api-reference" element={<ApiReference />} />
        <Route path="/account" element={<Account />} />
        {/* <Route path="/available-coins-pairs" element={<AvailableCoinsPairs />} /> */}
        {/* <Route path="/fee-management" element={<FeeManagement />} /> */}
        <Route path="/whitelisted-ips" element={<WhitelistedIps />} />
        <Route path="/whitelisted-websites" element={<WhitelistedWebsites />} />
        <Route path="/webhooks" element={<Webhooks />} />
        <Route path="/widget" element={<Widget />} />
        <Route path="/referral" element={<Referral />} />
        <Route path="/linked-wallets" element={<LinkedWallets />} />
        <Route path="/security" element={<Security />} />
        <Route path="/sub-partner-fees" element={<SubPartnerFees />} />
        <Route path="/edit-wallet" element={<EditWallet />} />
        <Route path="/vip-tiers" element={<VipTiers />} />
        <Route path="/revenue-share" element={<RevenueShare />} />
        {/* KOL campaigns + agency (KOL_CAMPAIGNS_AGENCY_PLAN.md) */}
        <Route path="/campaigns" element={<Navigate to="/referral" />} />
        <Route path="/campaigns/stats" element={<CampaignStats />} />
        <Route path="/agency" element={<AgencyOverview />} />
        <Route path="/agency/partners" element={<AgencyPartners />} />
        <Route path="/agency/invites" element={<AgencyInvites />} />

        {/* Redirect root "/" to "/overview" */}
        <Route path="/" element={<Navigate to="/overview" />} />

        {/* Catch-all route for undefined paths */}
        <Route path="*" element={<Navigate to="/overview" />} />
        </Routes>
      </div>
    </div>
  );
};

export default Main;
